import { ReactNode } from 'react'

import { Button } from '@/shared/ui'

import cl from './style.module.scss'

interface ResendButtonProps {
	isLoading: boolean
	isDisabled: boolean
	children: ReactNode
	resendLabel?: string
	onResend: () => void
}

export const ResendButton = (props: ResendButtonProps) => {
	const { children, isDisabled, isLoading, resendLabel, onResend } = props

	return (
		<div>
			{isDisabled ? (
				<p className={cl.countdown}>{children}</p>
			) : (
				<Button theme="link" onClick={onResend} className={cl.resendButton} disabled={isLoading || isDisabled}>
					{resendLabel || 'Отправить повторно'}
				</Button>
			)}
		</div>
	)
}
